/* eslint-disable react-refresh/only-export-components */
import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from 'react';

/**
 * Calendly URL — Océanne's open question #10 (not yet provided).
 * When the URL is available, replace the empty string below. The CalendlyModal
 * will automatically switch from fallback message to embedded iframe.
 */
const CALENDLY_URL = '';

interface CalendlyContextValue {
  isOpen: boolean;
  url: string;
  open: () => void;
  close: () => void;
}

const CalendlyContext = createContext<CalendlyContextValue | null>(null);

interface ProviderProps {
  children: ReactNode;
}

export function CalendlyProvider({ children }: ProviderProps) {
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);

  const value = useMemo<CalendlyContextValue>(
    () => ({ isOpen, url: CALENDLY_URL, open, close }),
    [isOpen, open, close]
  );

  return <CalendlyContext.Provider value={value}>{children}</CalendlyContext.Provider>;
}

export function useCalendly(): CalendlyContextValue {
  const ctx = useContext(CalendlyContext);
  if (!ctx) {
    throw new Error('useCalendly must be used inside <CalendlyProvider>.');
  }
  return ctx;
}
